// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:320px) {
    .viewAllMusic {
        font-size: var(--small-sm-heading);
    }

    .small-sm-heading {
        font-size: var(--small-sm-heading);
    }

    .navHeadingMusic {
        font-size: var(--small-md-heading);
        font-weight: bold;
    }

    .themeTwoHeader {
        padding: 8px;
    }

    .swiperThemeTwo .bannerWrapper {
        padding: 15px;
    }



}

@media screen and (min-width:425px) {
    .viewAllMusic {
        font-size: var(--small-md-heading);
    }

    .navHeadingMusic {
        font-size: var(--small-lg-heading);
        font-weight: bold;
    }

    .listPanelPrice .priceText {
        width: 61px;
        text-align: center;
    }

    .listPanelPrice {
        width: 82px !important;
    }
}

@media screen and (min-width:768px) {
    .small-md-heading {
        font-size: var(--small-md-heading);
    }

    .themeTwoHeader {
        padding: 7px 30px;
    }

    .swiperThemeTwo .bannerWrapper {
        padding: 50px 30px;
    }

}

@media screen and (min-width:992px) {
    .small-lg-heading {
        font-size: var(--small-lg-heading);
        line-height: calc(var(--small-lg-heading) * 2);
    }

    .profileThemeTwo {
        padding: 17px 30px;
    }

    .swiperThemeTwo .bannerWrapper {
        padding: 90px 60px;
    }
}

@media screen and (min-width:1024px) {
    /* .swiperThemeTwo .swiper-pagination-bullet {
        width: calc(100% / 5);
        height: 150px !important;
    } */
}

@media screen and (min-width:1200px) {

    /* .swiperThemeTwo .swiper-pagination-bullet {
        width: 230px;
        height: 150px !important;
    } */
    .swiperThemeTwo .swiper-pagination-bullet {
        width: 180px;
        height: 100px !important;
    }

    .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide+.swiper-slide+.swiper-slide .homeSwiperContainer {
        right: 24px;
        left: auto;
    }

}

@media screen and (min-width:1440px) {}

@media screen and (max-width:768px) {
    .themeTwoNavMobileFixed {
        position: fixed;
        top: 0;
        left: -100%;
        width: 100%;
        padding: 75px 13px !important;
        height: 100vh;
        flex-direction: column;
        justify-content: unset !important;
        transition: left 0.6s linear;

    }

    .themeTwoNavMobileFixed.active {
        left: 0;
    }

    .homePageSwiper .swiper-button-next {
        display: none;
    }

    .homePageSwiper .swiper-button-prev {
        display: none;
    }

    .bootstrapTable .react-bootstrap-table-pagination {
        gap: 14px;
        margin: 0 !important;
    }

    .hover-card-mobile-none {
        display: none !important;
    }

    .languageText {
        font-size: 16px;
    }
}

@media screen and (max-width: 425px) {
    .homeSwiperContainer {
        width: 267px;
    }

    .homePageSwiper .swiper-slide:hover .homeSwiperContainer {
        transform: scale(1.1);
    }

    .homePageSwiper .swiper-slide-active .homeSwiperContainer {
        left: 7px;
    }

    .homePageSwiper .swiper-slide:nth-last-child(2) .homeSwiperContainer {
        right: 7px;
    }

    .homePageSwiper .swiper-slide:last-child .homeSwiperContainer {
        right: 7px;
    }

    .homePageSwiper.categorySizeSmall .swiper-slide {
        height: 165px !important;
    }

    .swiperHeading {
        font-size: 18px;
        line-height: 30px;
        margin-bottom: 6px;
    }

    .homePageSwiper .swiper-slide {
        height: 305px;
        display: inline-table
    }

    .loaderText {
        font-size: 15px;
        line-height: 20px;
    }
}


@media (min-width: 1920px) and (max-width: 2560px) {
    .homePageSwiper .swiper-slide {
        width: 100%;
        height: 400px;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        z-index: 0;
    }

    .homeSwiperContainer {
        height: 380px;
        width: 250px;
        top: 10px;
        left: 0;
    }

    .homePageSwiper .swiper-slide:nth-child(6) .homeSwiperContainer {
        right: 10px;
        left: auto;
    }

    .desktopview-category-image {
        height: 225px !important;
    }
}

@media screen and (min-width: 1600px) {
    .homePageSwiper .swiper-slide {
        width: 100%;
        height: 350px;
        text-align: center;
        font-size: 18px;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        z-index: 0;
    }

    .homeSwiperContainer {
        min-height: 325px;
        width: 250px;
    }

    .homePageSwiper .swiper-slide:nth-child(6) .homeSwiperContainer {
        right: 10px;
        left: auto;
    }
}

@media screen and (min-width: 1024px) and (max-width: 1200px) {
    .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide+.swiper-slide .homeSwiperContainer {
        right: 38px;
        left: auto;
    }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
    .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide .homeSwiperContainer {
        right: 38px;
        left: auto;
    }
}

@media screen and (min-width: 576px) and (max-width: 768px) {
    .homePageSwiper .swiper-slide-next+.swiper-slide .homeSwiperContainer {
        right: 38px;
        left: auto;
    }
}

@media screen and (min-width: 320px) and (max-width: 576px) {
    .homePageSwiper .swiper-slide-next .homeSwiperContainer {
        right: 13px;
        left: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/response.css"],"names":[],"mappings":"AAAA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;QAClC,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;;;AAIJ;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;QAClC,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;AAEJ;;AAEA;IACI;QACI,kCAAkC;QAClC,8CAA8C;IAClD;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;;;OAGG;AACP;;AAEA;;IAEI;;;OAGG;IACH;QACI,YAAY;QACZ,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;AAEJ;;AAEA,sCAAsC;;AAEtC;IACI;QACI,eAAe;QACf,MAAM;QACN,WAAW;QACX,WAAW;QACX,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,iCAAiC;QACjC,4BAA4B;;IAEhC;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,oBAAoB;IACxB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,SAAS;QACT,OAAO;IACX;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,eAAe;QACf,uBAAuB;QACvB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ","sourcesContent":["@media screen and (min-width:320px) {\n    .viewAllMusic {\n        font-size: var(--small-sm-heading);\n    }\n\n    .small-sm-heading {\n        font-size: var(--small-sm-heading);\n    }\n\n    .navHeadingMusic {\n        font-size: var(--small-md-heading);\n        font-weight: bold;\n    }\n\n    .themeTwoHeader {\n        padding: 8px;\n    }\n\n    .swiperThemeTwo .bannerWrapper {\n        padding: 15px;\n    }\n\n\n\n}\n\n@media screen and (min-width:425px) {\n    .viewAllMusic {\n        font-size: var(--small-md-heading);\n    }\n\n    .navHeadingMusic {\n        font-size: var(--small-lg-heading);\n        font-weight: bold;\n    }\n\n    .listPanelPrice .priceText {\n        width: 61px;\n        text-align: center;\n    }\n\n    .listPanelPrice {\n        width: 82px !important;\n    }\n}\n\n@media screen and (min-width:768px) {\n    .small-md-heading {\n        font-size: var(--small-md-heading);\n    }\n\n    .themeTwoHeader {\n        padding: 7px 30px;\n    }\n\n    .swiperThemeTwo .bannerWrapper {\n        padding: 50px 30px;\n    }\n\n}\n\n@media screen and (min-width:992px) {\n    .small-lg-heading {\n        font-size: var(--small-lg-heading);\n        line-height: calc(var(--small-lg-heading) * 2);\n    }\n\n    .profileThemeTwo {\n        padding: 17px 30px;\n    }\n\n    .swiperThemeTwo .bannerWrapper {\n        padding: 90px 60px;\n    }\n}\n\n@media screen and (min-width:1024px) {\n    /* .swiperThemeTwo .swiper-pagination-bullet {\n        width: calc(100% / 5);\n        height: 150px !important;\n    } */\n}\n\n@media screen and (min-width:1200px) {\n\n    /* .swiperThemeTwo .swiper-pagination-bullet {\n        width: 230px;\n        height: 150px !important;\n    } */\n    .swiperThemeTwo .swiper-pagination-bullet {\n        width: 180px;\n        height: 100px !important;\n    }\n\n    .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide+.swiper-slide+.swiper-slide .homeSwiperContainer {\n        right: 24px;\n        left: auto;\n    }\n\n}\n\n@media screen and (min-width:1440px) {}\n\n@media screen and (max-width:768px) {\n    .themeTwoNavMobileFixed {\n        position: fixed;\n        top: 0;\n        left: -100%;\n        width: 100%;\n        padding: 75px 13px !important;\n        height: 100vh;\n        flex-direction: column;\n        justify-content: unset !important;\n        transition: left 0.6s linear;\n\n    }\n\n    .themeTwoNavMobileFixed.active {\n        left: 0;\n    }\n\n    .homePageSwiper .swiper-button-next {\n        display: none;\n    }\n\n    .homePageSwiper .swiper-button-prev {\n        display: none;\n    }\n\n    .bootstrapTable .react-bootstrap-table-pagination {\n        gap: 14px;\n        margin: 0 !important;\n    }\n\n    .hover-card-mobile-none {\n        display: none !important;\n    }\n\n    .languageText {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    .homeSwiperContainer {\n        width: 267px;\n    }\n\n    .homePageSwiper .swiper-slide:hover .homeSwiperContainer {\n        transform: scale(1.1);\n    }\n\n    .homePageSwiper .swiper-slide-active .homeSwiperContainer {\n        left: 7px;\n    }\n\n    .homePageSwiper .swiper-slide:nth-last-child(2) .homeSwiperContainer {\n        right: 7px;\n    }\n\n    .homePageSwiper .swiper-slide:last-child .homeSwiperContainer {\n        right: 7px;\n    }\n\n    .homePageSwiper.categorySizeSmall .swiper-slide {\n        height: 165px !important;\n    }\n\n    .swiperHeading {\n        font-size: 18px;\n        line-height: 30px;\n        margin-bottom: 6px;\n    }\n\n    .homePageSwiper .swiper-slide {\n        height: 305px;\n        display: inline-table\n    }\n\n    .loaderText {\n        font-size: 15px;\n        line-height: 20px;\n    }\n}\n\n\n@media (min-width: 1920px) and (max-width: 2560px) {\n    .homePageSwiper .swiper-slide {\n        width: 100%;\n        height: 400px;\n        background: transparent;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 6px;\n        z-index: 0;\n    }\n\n    .homeSwiperContainer {\n        height: 380px;\n        width: 250px;\n        top: 10px;\n        left: 0;\n    }\n\n    .homePageSwiper .swiper-slide:nth-child(6) .homeSwiperContainer {\n        right: 10px;\n        left: auto;\n    }\n\n    .desktopview-category-image {\n        height: 225px !important;\n    }\n}\n\n@media screen and (min-width: 1600px) {\n    .homePageSwiper .swiper-slide {\n        width: 100%;\n        height: 350px;\n        text-align: center;\n        font-size: 18px;\n        background: transparent;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 6px;\n        z-index: 0;\n    }\n\n    .homeSwiperContainer {\n        min-height: 325px;\n        width: 250px;\n    }\n\n    .homePageSwiper .swiper-slide:nth-child(6) .homeSwiperContainer {\n        right: 10px;\n        left: auto;\n    }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1200px) {\n    .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide+.swiper-slide .homeSwiperContainer {\n        right: 38px;\n        left: auto;\n    }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n    .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide .homeSwiperContainer {\n        right: 38px;\n        left: auto;\n    }\n}\n\n@media screen and (min-width: 576px) and (max-width: 768px) {\n    .homePageSwiper .swiper-slide-next+.swiper-slide .homeSwiperContainer {\n        right: 38px;\n        left: auto;\n    }\n}\n\n@media screen and (min-width: 320px) and (max-width: 576px) {\n    .homePageSwiper .swiper-slide-next .homeSwiperContainer {\n        right: 13px;\n        left: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
